import { create } from 'zustand';

type SearchStoreType = {
    searchValue: string;
    setSearchValue: (searchValue: string) => void;
};

const useSearch = create<SearchStoreType>((set) => ({
    searchValue: '',
    setSearchValue: (searchValue) => set({ searchValue }),
}));

export default useSearch;
